import * as React from "react";
import cx from "classnames";

const styles = require("./outlineButton.scss");

interface IProps {
  width: number;
  height: number;
  hoverColor?: "grey" | "vingle-red";
  text?: React.ReactNode;
  title?: string;
  onClick?: VoidFunction;
  onHover?: (state: boolean) => void;
}

interface IState {
  isInHover: boolean;
}

class OutlineButton extends React.Component<IProps, IState> {
  public static defaultProps: Pick<IProps, "hoverColor"> = {
    hoverColor: "grey",
  };

  public state: IState = {
    isInHover: false,
  };

  public render() {
    const { width, height, onClick, hoverColor, children, title } = this.props;
    const hoverTheme =
      hoverColor === "grey" ? styles.greyHover : styles.vingleRedHover;
    return (
      <button
        type="button"
        className={cx(styles.wrapper, hoverTheme)}
        style={{
          width,
          height,
        }}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={onClick}
        title={title}
      >
        {children}
      </button>
    );
  }

  private readonly changeIsInHoverState = (state: boolean) => {
    if (this.state.isInHover !== state) {
      if (this.props.onHover) {
        this.props.onHover(state);
      }
      this.setState({
        isInHover: state,
      });
    }
  };

  private readonly handleMouseEnter = () => {
    this.changeIsInHoverState(true);
  };

  private readonly handleMouseLeave = () => {
    this.changeIsInHoverState(false);
  };
}

export default OutlineButton;
